/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is this typing test free?`)
};

const es_typing_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Este test de mecanografía es gratis?`)
};

const de_typing_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist dieser Tipptest kostenlos?`)
};

const nl_typing_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is deze typetest gratis?`)
};

const fr_typing_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce test de frappe est-il gratuit ?`)
};

const it_typing_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo test di digitazione è gratuito?`)
};

const pt_br2_typing_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este teste de digitação é grátis?`)
};

const pt_typing_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este teste de escrita é gratuito?`)
};

const ja_typing_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このタイピングテストは無料ですか？`)
};

const zh_typing_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这个打字测试免费吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_hub_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_hub_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_hub_faq3_q", locale)
	if (locale === "en") return en_typing_hub_faq3_q(inputs)
	if (locale === "es") return es_typing_hub_faq3_q(inputs)
	if (locale === "de") return de_typing_hub_faq3_q(inputs)
	if (locale === "nl") return nl_typing_hub_faq3_q(inputs)
	if (locale === "fr") return fr_typing_hub_faq3_q(inputs)
	if (locale === "it") return it_typing_hub_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_typing_hub_faq3_q(inputs)
	if (locale === "pt") return pt_typing_hub_faq3_q(inputs)
	if (locale === "ja") return ja_typing_hub_faq3_q(inputs)
	return zh_typing_hub_faq3_q(inputs)
};